import { render, staticRenderFns } from "./agreement2.vue?vue&type=template&id=3c5e94f9&scoped=true&"
import script from "./agreement2.vue?vue&type=script&lang=js&"
export * from "./agreement2.vue?vue&type=script&lang=js&"
import style0 from "./agreement2.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./agreement2.vue?vue&type=style&index=1&id=3c5e94f9&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e94f9",
  null
  
)

export default component.exports